import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

import { supabase } from "@/lib/supabase"

interface MarkAttendanceParams {
  bookingId: string
  applicationId: string
  attended: boolean | null
  eventType: "orientation" | "vehicle"
}

export function useMarkAttendance() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ bookingId, applicationId, attended, eventType }: MarkAttendanceParams) => {
      const { data, error } = await supabase.functions.invoke("mark-attendance", {
        body: {
          bookingId,
          applicationId,
          attended,
          eventType,
        },
      })

      if (error) {
        console.error("Error marking attendance:", error)
        throw new Error(error.message || "Failed to update attendance")
      }

      return data
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ["sessionAttendees"],
      })

      // Show success toast
      toast.success("Attendance Updated", {
        description:
          data.message || variables.attended === null
            ? "Attendance reset successfully"
            : `Attendance ${variables.attended ? "marked" : "unmarked"} successfully`,
      })
    },
    onError: (error) => {
      // Show error toast
      toast.error("Error", {
        description: error instanceof Error ? error.message : "Failed to update attendance",
      })
    },
  })
}
